module.exports = __webpack_public_path__ + "media/Images/investment-lineup-header-001-d0bf88984530c248f934ee542b1907c3.jpg";